"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStateObjectByHash = exports.useStateObject = exports.useSpace = exports.usePeerResourcesUpdater = exports.PeerResourcesUpdater = exports.usePeerResources = exports.PeerResources = void 0;
const core_1 = require("@hyper-hyper-space/core");
const react_1 = __importStar(require("react"));
const PeerResources = react_1.default.createContext(undefined);
exports.PeerResources = PeerResources;
const PeerResourcesUpdater = react_1.default.createContext(() => { });
exports.PeerResourcesUpdater = PeerResourcesUpdater;
const usePeerResources = () => {
    return react_1.useContext(PeerResources);
};
exports.usePeerResources = usePeerResources;
const usePeerResourcesUpdater = () => {
    return react_1.useContext(PeerResourcesUpdater);
};
exports.usePeerResourcesUpdater = usePeerResourcesUpdater;
const useSpace = (init, broadcast) => {
    const resources = usePeerResources();
    const [entryPoint, setEntryPoint] = react_1.useState(undefined);
    react_1.useEffect(() => {
        const space = init !== undefined ? new core_1.Space(init, resources) : undefined;
        let initialized = false;
        let destroyed = false;
        const doBroadcast = broadcast !== undefined ? broadcast : (init === null || init === void 0 ? void 0 : init.wordCode) !== undefined;
        if (space !== undefined && init !== undefined) {
            space.entryPoint.then(async (obj) => {
                if (!destroyed) {
                    if (doBroadcast) {
                        space.startBroadcast();
                    }
                    obj.setResources(resources);
                    if (resources.store) {
                        await resources.store.save(obj);
                    }
                    obj.startSync();
                    setEntryPoint(obj);
                    initialized = true;
                }
            });
        }
        return () => {
            destroyed = true;
            if (initialized) {
                if (doBroadcast) {
                    space === null || space === void 0 ? void 0 : space.stopBroadcast();
                }
                space === null || space === void 0 ? void 0 : space.getEntryPoint().then((obj) => {
                    obj.stopSync();
                });
            }
        };
    }, [init, broadcast, resources]);
    return entryPoint;
};
exports.useSpace = useSpace;
class StateObject {
    constructor(obj) {
        this.value = obj;
    }
}
const useStateObjectByHash = (hash) => {
    const resources = usePeerResources();
    const [stateObject, setSateObject] = react_1.useState(undefined);
    react_1.useEffect(() => {
        var _a;
        let destroyed = false;
        let obj = undefined;
        let mutCallback = (_mut) => {
            if (obj !== undefined) {
                setSateObject(new StateObject(obj));
            }
        };
        if (hash !== undefined) {
            (_a = resources.store) === null || _a === void 0 ? void 0 : _a.load(hash).then((obj) => {
                if (obj !== undefined) {
                    if (obj instanceof core_1.MutableObject) {
                        obj.watchForChanges(true);
                        obj.loadAllChanges().then(() => {
                            if (!destroyed) {
                                setSateObject(new StateObject(obj));
                                obj.addMutationCallback(mutCallback);
                            }
                        });
                    }
                    else {
                        setSateObject(new StateObject(obj));
                    }
                }
            });
        }
        return () => {
            destroyed = true;
            if (hash !== undefined && obj !== undefined && obj instanceof core_1.MutableObject) {
                obj.watchForChanges(false);
                obj.deleteMutationCallback(mutCallback);
            }
        };
    }, [resources, hash]);
    return stateObject;
};
exports.useStateObjectByHash = useStateObjectByHash;
const useStateObject = (objOrPromise) => {
    const init = objOrPromise instanceof core_1.HashedObject ? objOrPromise : undefined;
    const [stateObject, setSateObject] = react_1.useState(new StateObject(init));
    react_1.useEffect(() => {
        let prom;
        if (objOrPromise instanceof Promise) {
            prom = objOrPromise;
        }
        else if (objOrPromise !== undefined) {
            prom = Promise.resolve(objOrPromise);
        }
        else {
            prom = undefined;
        }
        let loadedObj;
        let destroyed = false;
        let mutCallback = (_mut) => {
            setSateObject(new StateObject(loadedObj));
        };
        prom === null || prom === void 0 ? void 0 : prom.then(obj => {
            loadedObj = obj;
            if (obj !== undefined) {
                if (obj instanceof core_1.MutableObject) {
                    obj.watchForChanges(true);
                    obj.loadAllChanges().then(() => {
                        if (!destroyed) {
                            console.log('@hyper-hyper-space/react: State loaded for ' + obj.hash());
                            setSateObject(new StateObject(obj));
                            obj.addMutationCallback(mutCallback);
                        }
                    });
                }
                else {
                    if (!destroyed) {
                        console.log('@hyper-hyper-space/react: Loaded ' + obj.hash());
                        setSateObject(new StateObject(obj));
                    }
                }
            }
        });
        return () => {
            destroyed = true;
            if (loadedObj !== undefined && loadedObj instanceof core_1.MutableObject) {
                loadedObj.watchForChanges(false);
                loadedObj.deleteMutationCallback(mutCallback);
            }
        };
    }, [objOrPromise]);
    return stateObject;
};
exports.useStateObject = useStateObject;
//# sourceMappingURL=bindings.js.map